import { IApplicationState, TCardId } from '../../../../../../../../types/types';
import { getCardSubcards } from '../../../../../../../../store/model/selectors/getCardSubcards';
import { getCard } from '../../../../../../../../store/model/selectors/getCard';
import { getCardStartDate } from '../../../../../../../../store/model/selectors/getCardStartDate';

export const getCardSubcardIdWithMinDate = (
    state: IApplicationState,
    cardId: TCardId,
): number => {
    const card = getCard(state, cardId);
    if (!card) return null;

    const subcards = getCardSubcards(state, cardId);

    let subcardMin = Infinity;
    let subcardIdWithMinDate = Infinity;
    subcards.forEach(card => {
        const dueDate = getCardStartDate(state, card.id);
        if (dueDate < subcardMin) {
            subcardMin = dueDate;
            subcardIdWithMinDate = card.id
        }
    });
    return subcardIdWithMinDate;
}
